import cls from "./BlogTable.module.css";
import { TableCell } from "@/types/IBlogContent";

interface BlogTableProps {
    columns: string[];
    rows: TableCell[][];
}

const toneClass: Record<string, string> = {
    green: cls.badgeGreen,
    orange: cls.badgeOrange,
    red: cls.badgeRed,
    gray: cls.badgeGray,
};

export const BlogTable = ({ columns, rows }: BlogTableProps) => {
    return (
        <div className={cls.tableWrapper}>
            <table className={cls.table}>
                <thead>
                    <tr>
                        {columns.map((column, index) => (
                            <th key={index} dangerouslySetInnerHTML={{ __html: column }} />
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex}>
                                    {typeof cell === "string" ? (
                                        <span dangerouslySetInnerHTML={{ __html: cell }} />
                                    ) : (
                                        <span className={`${cls.badge} ${toneClass[cell.tone]}`}>{cell.text}</span>
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
